import { Link, useLocation } from 'react-router-dom'

const navItems = [
  { label: 'Resumen', href: '/admin', icon: 'ph-house' },
  { label: 'Gestionar Contenido', href: '/admin/content', icon: 'ph-article' },
  { label: 'Gestión de Medios', href: '/admin/media', icon: 'ph-image' },
  { label: 'Envíos de Contacto', href: '/admin/contact-submissions', icon: 'ph-inbox' },
]

interface AdminSidebarProps {
  onLogout?: () => void
  adminName?: string
  isCollapsed?: boolean
}

function AdminSidebar({ onLogout, adminName = 'Administrador', isCollapsed = false }: AdminSidebarProps) {
  const location = useLocation()

  return (
    <div className={`bg-primary text-white h-full flex flex-col transition-all duration-300 ${isCollapsed ? 'w-16' : 'w-64'}`}>
      <div className="p-4 border-b border-primary-dark">
        <div className="flex items-center space-x-2">
          <img src="/Docs/Fotos/Logo recortado.png" alt="Logo" className="h-8 w-8" />
          {!isCollapsed && <span className="font-bold text-lg">Panel Admin</span>}
        </div>
        {!isCollapsed && <span className="text-xs text-gray-300 mt-1">El Horcon Criollo</span>}
      </div>

      <nav className="flex-1 p-2">
        <ul className="space-y-1">
          {navItems.map((item) => (
            <li key={item.href}>
              <Link
                to={item.href}
                className={`flex items-center space-x-3 px-3 py-2 rounded-lg hover:bg-primary-dark transition-colors ${
                  location.pathname === item.href ? 'bg-primary-dark' : ''
                }`}
              >
                <i className={`${item.icon} text-xl`}></i>
                {!isCollapsed && <span>{item.label}</span>}
              </Link>
            </li>
          ))}
        </ul>
      </nav>

      <div className="p-4 border-t border-primary-dark">
        {!isCollapsed && (
          <div className="mb-2">
            <span className="text-xs text-gray-300">Usuario:</span>
            <span className="block text-sm font-medium">{adminName}</span>
          </div>
        )}
        <button
          onClick={onLogout}
          className="w-full flex items-center space-x-3 px-3 py-2 rounded-lg hover:bg-primary-dark transition-colors"
        >
          <i className="ph ph-sign-out text-xl"></i>
          {!isCollapsed && <span>Cerrar sesión</span>}
        </button>
      </div>
    </div>
  )
}

export default AdminSidebar